import axios from "axios";
import { useMemo } from "react";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "zapiudp_session";

export const getPToken = () => localStorage.getItem(TOKEN_KEY);
export const setPToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const publicApi = axios.create({ baseURL: API, withCredentials: true });
publicApi.interceptors.request.use((c) => {
  const t = getPToken();
  if (t) c.headers["X-Participant-Token"] = t;
  return c;
});

export const errMsg = (e, fallback = "Não foi possível concluir. Tente novamente.") => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : fallback;
};

export function useStaffApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const inst = axios.create({ baseURL: API });
    inst.interceptors.request.use(async (c) => {
      c.headers.Authorization = `Bearer ${await getToken()}`;
      return c;
    });
    return inst;
  }, [getToken]);
}

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  }
}
